import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chevron-left.svg'
import _imports_1 from '@/assets/img/chevron-right.svg'
import _imports_2 from '@/assets/img/list.svg'


const _withScopeId = n => (_pushScopeId("data-v-272ca420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = { class: "calendar" }
const _hoisted_4 = { class: "calendar-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "calendar-grid" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "day-number"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-3 mb-0"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Calendar",
        text: "Calendar",
        class: "mb-0"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args))),
            class: "btn btn-secondary withBorder p-2"
          }, _hoisted_6),
          _createElementVNode("h2", null, _toDisplayString(_ctx.currentMonthYear), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args))),
            class: "btn btn-secondary withBorder p-2"
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayNames, (day) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "day-name",
              key: day
            }, _toDisplayString(day), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarDays, (cell, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["day-cell", { 
                        'past-day': _ctx.isPastDay(cell.date),
                        'today': _ctx.isToday(cell.date) 
                    }]),
              onClick: ($event: any) => (cell.date && _ctx.handleDayClick(cell.date))
            }, [
              (cell.date)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(cell.date.getDate()), 1))
                : _createCommentVNode("", true),
              (cell.date && _ctx.getCertificationsByDate(cell.date))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCertificationsByDate(cell.date), (item, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item.provider.text) + ": " + _toDisplayString(item.certificationName), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_10))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_router_link, {
      class: "btn btn-secondary withBorder fixedBottomRight",
      to: "/providers"
    }, {
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    })
  ], 64))
}